export const getJobPostingAccessStatus = (subscriptions) => {
  if (!subscriptions?.length) {
    return { canPost: false, reason: "no_subscription" };
  }

  const now = new Date();
  const activeWithQuota = subscriptions.filter(
    (sub) =>
      sub.is_active &&
      sub.expires_in &&
      new Date(sub.expires_in) >= now &&
      sub.avail_jobposting > 0
  );

  if (activeWithQuota.length > 0) {
    return {
      canPost: true,
      remaining: activeWithQuota.reduce(
        (sum, sub) => sum + (sub.avail_jobposting || 0),
        0
      ),
    };
  }

  const hasAnySubscription = subscriptions.some((sub) => sub.is_active);
  if (hasAnySubscription) {
    return { canPost: false, reason: "quota_exhausted" };
  }

  return { canPost: false, reason: "no_subscription" };
};

export const JOB_POSTING_ACCESS_MESSAGES = {
  no_subscription:
    "Please purchase a job posting package before you can post a job.",
  quota_exhausted:
    "Your job posting quota has been used. Please purchase a new package to post more jobs.",
};
